import { Identifiable } from "./identifiable";
import { role, Role } from "./role";

type InvitedMember = {
  email: string;
  firstName: string;
  lastName: string;
  language: "fr" | "en";
  role: Identifiable<Role> | null;
};

const invitedMember: InvitedMember = {
  email: "",
  firstName: "",
  lastName: "",
  language: "fr",
  role: null,
};

export type { InvitedMember };

export { invitedMember };
